import axios from "axios";
import config from "../../config";
import axiosInstance from "../../utils/axiosInstance";

const TestimonialManager = {
  // Admin operations
  getAllTestimonials: async () => {
    try {
      const response = await axiosInstance.get(`/testimonials/all`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error fetching testimonials:", error);
      throw error;
    }
  },

  createTestimonial: async (testimonialData) => {
    try {
      // Handle image upload if avatarFile is present
      if (testimonialData.avatarFile) {
        const formData = new FormData();
        formData.append('avatar', testimonialData.avatarFile);
        
        // Upload avatar first
        const uploadResponse = await axiosInstance.post(`/testimonials/upload-avatar`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        
        // Replace avatarFile with the uploaded file name
        testimonialData.avatar = uploadResponse.data.responseData.fileName;
        delete testimonialData.avatarFile;
      }
      
      const response = await axiosInstance.post(`/testimonials/create`, testimonialData);
      return response.data.responseData;
    } catch (error) {
      console.error("Error creating testimonial:", error);
      throw error;
    }
  },

  updateTestimonial: async (testimonialId, testimonialData) => {
    try {
      // Handle image upload if avatarFile is present
      if (testimonialData.avatarFile) {
        const formData = new FormData();
        formData.append('avatar', testimonialData.avatarFile);
        
        // Upload avatar first
        const uploadResponse = await axiosInstance.post(`/testimonials/upload-avatar`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        
        // Replace avatarFile with the uploaded file name
        testimonialData.avatar = uploadResponse.data.responseData.fileName;
        delete testimonialData.avatarFile;
      }
      
      const response = await axiosInstance.put(`/testimonials/update/${testimonialId}`, testimonialData);
      return response.data.responseData;
    } catch (error) {
      console.error("Error updating testimonial:", error);
      throw error;
    }
  },

  updateTestimonialStatus: async (testimonialId, status) => {
    try {
      const response = await axiosInstance.put(`/testimonials/update-status/${testimonialId}?status=${status}`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error updating testimonial status:", error);
      throw error;
    }
  },

  toggleFeatured: async (testimonialId) => {
    try {
      const response = await axiosInstance.put(`/testimonials/toggle-featured/${testimonialId}`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error toggling featured status:", error);
      throw error;
    }
  },

  updateDisplayOrder: async (testimonialId, displayOrder) => {
    try {
      const response = await axiosInstance.put(`/testimonials/update-order/${testimonialId}?displayOrder=${displayOrder}`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error updating display order:", error);
      throw error;
    }
  },

  deleteTestimonial: async (testimonialId) => {
    try {
      const response = await axiosInstance.delete(`/testimonials/delete/${testimonialId}`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error deleting testimonial:", error);
      throw error;
    }
  },

  uploadAvatar: async (file) => {
    try {
      const formData = new FormData();
      formData.append('avatar', file);
      
      const response = await axiosInstance.post(`/testimonials/upload-avatar`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data.responseData;
    } catch (error) {
      console.error("Error uploading avatar:", error);
      throw error;
    }
  },

  getTestimonialById: async (testimonialId) => {
    try {
      const response = await axiosInstance.get(`/testimonials/${testimonialId}`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error fetching testimonial:", error);
      throw error;
    }
  },

  // Public operations (these don't need admin auth, so use regular axios)
  getApprovedTestimonials: async () => {
    try {
      const response = await axios.get(`${config.url}/api/testimonials/approved`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error fetching approved testimonials:", error);
      throw error;
    }
  },

  getFeaturedTestimonials: async () => {
    try {
      const response = await axios.get(`${config.url}/api/testimonials/featured`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error fetching featured testimonials:", error);
      throw error;
    }
  },

  // User operations (these don't need admin auth, so use regular axios)
  submitTestimonial: async (testimonialData) => {
    try {
      const response = await axios.post(`${config.url}/api/testimonials/submit`, testimonialData);
      return response.data.responseData;
    } catch (error) {
      console.error("Error submitting testimonial:", error);
      throw error;
    }
  },

  getUserTestimonials: async (userId) => {
    try {
      const response = await axios.get(`${config.url}/api/testimonials/user/${userId}`);
      return response.data.responseData;
    } catch (error) {
      console.error("Error fetching user testimonials:", error);
      throw error;
    }
  }
};

const formatDateTimeFromArray = (arr) => {
  if (!Array.isArray(arr) || arr.length < 6) return "";
  
  const dateTime = new Date(
    arr[0],        // year
    arr[1] - 1,    // month (0-indexed)
    arr[2],        // day
    arr[3] || 0,   // hour
    arr[4] || 0,   // minute
    arr[5] || 0    // second
  ).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });
  
  return dateTime;
};

export default TestimonialManager;